export const convertToISO8601 = (date, time, gmtCorrection) => {
  const year = date.$y;
  const month = date.$M;
  const day = date.$D;
  const hours = time.$H;
  const minutes = time.$m;

  // TODO
  const gmtCorrectionFinal = gmtCorrection ? gmtCorrection : "05:30";

  // Convert GMT correction to minutes
  const [hoursCorrection, minutesCorrection] = gmtCorrectionFinal.split(":");
  const totalMinutesCorrection =
    parseInt(hoursCorrection, 10) * 60 + parseInt(minutesCorrection, 10);

  // Create Date object
  const d = new Date(
    Date.UTC(year, month, day, hours, minutes) - totalMinutesCorrection * 60000
  );

  // Format date to ISO 8601
  const isoString = d.toISOString();

  return isoString;
};
